import { Form, Tabs } from 'antd'
import React, { useEffect, useState } from 'react'
import { formatPhoneNumber } from 'react-phone-number-input'
import { get } from '../../Common/api'
import BoxAccessibilityTab from './BoxAccessibilityTab'
import BoxAnnouncementTab from './BoxAnnouncementTab'
import BoxLocationTab from './BoxLocationTab'
import BoxSetupTab from './BoxSetupTab'
import BoxIntervenersTab from './BoxIntervenersTab'

const displayLogin = (list, id) => {
  if (list.length === 0) {
    return false
  } else {
    return list.find(tc => tc.value === id)?.label === 'Tessan'
  }
}

export default function BoxForm ({ form, onFinish, owners, state }) {
  const [mapVisible, setMapVisible] = useState(false)
  const [interveners, setInterveners] = useState([])
  const [teleconsultingCompanies, setTeleconsultingCompanies] = useState([])
  const [displayTeleconsultingLogin, setDisplayTeleconsultingLogin] = useState(false)

  const getInterveners = async () => {
    await get({
      url: 'admin/interveners',
      params: {},
      onSuccess: (res) => {
        setInterveners(res.active.map(intervener => ({ ...intervener, key: intervener.id })))
      }
    })
  }

  const getTeleconsultingCompanies = async () => {
    await get({
      url: 'admin/teleconsulting_companies',
      params: {},
      onSuccess: (res) => {
        const list = res.map(company => ({ label: company.name, value: company.id, key: company.id }))
        setTeleconsultingCompanies(list)
        setDisplayTeleconsultingLogin(displayLogin(list, form.getFieldValue('teleconsulting_company_id')))
      }
    })
  }

  const onSubmit = (values) => {
    if (values.interphone) {
      values.interphone = formatPhoneNumber(values.interphone).replaceAll(' ', '')
    }
    if (values.gps_point) {
      values.gps_point = `POINT(${values.gps_point})`
    } else {
      values.gps_point = null
    }
    onFinish(values)
  }

  useEffect(() => {
    getInterveners()
    getTeleconsultingCompanies()
    setTimeout(() => {
      setMapVisible(true)
    }, 500)
  }, [])

  const TCOnChange = (value) => {
    setDisplayTeleconsultingLogin(displayLogin(teleconsultingCompanies, value))
  }

  return (
    <Form
      id="boxForm"
      form={form}
      labelAlign='left'
      layout='vertical'
      onFinish={onSubmit}
      disabled={state === 'show'}
      initialValues={{ interveners: [] }}
    >
      <Tabs
        defaultActiveKey='accessibility'
        items={[
          {
            label: 'Accessibilité',
            key: 'accessibility',
            children: <BoxAccessibilityTab form={form} state={state} />
          },
          {
            label: 'Intervenants',
            key: 'interveners',
            children: <BoxIntervenersTab form={form} interveners={interveners} />
          },
          {
            label: 'Localisation',
            key: 'location',
            children: <BoxLocationTab form={form} mapVisible={mapVisible} />
          },
          {
            label: 'Configuration',
            key: 'setup',
            children: <BoxSetupTab
              form={form}
              owners={owners}
              teleconsultingCompanies={teleconsultingCompanies}
              displayTeleconsultingLogin={displayTeleconsultingLogin}
              TCOnChange={TCOnChange}
            />
          },
          {
            label: 'Annonce',
            key: 'announcement',
            children: <BoxAnnouncementTab form={form} state={state} />
          }
        ]}
      >
      </Tabs>
    </Form >
  )
}
